import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { openCookieSettings } from '../utils/analytics';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-[#E5E0D8] pt-16 pb-8 mt-20">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6 lg:col-span-5">
            <Link
              to="/"
              className="inline-block mb-6 hover:opacity-80 transition-opacity outline-none"
            >
              <Logo iconSize="w-6 h-6" textSize="text-2xl" />
            </Link>
            <p className="text-sm text-[#6B6661] leading-relaxed mb-6">
              Data-driven curation of the best online courses for creative, tech, and freelance careers. Handpicked to help you build the life you want.
            </p>
            <div className="bg-[#FAF8F5] p-4 rounded-xl border border-[#E5E0D8] text-xs text-[#8A847A] leading-relaxed">
              <strong>Affiliate Disclosure:</strong> CurateEd is reader-supported. We may earn a commission when you purchase through links on our site, at no extra cost to you. This helps us maintain the site and continue curating high-quality content.{' '}
              <Link to="/disclaimer" className="underline hover:text-[#2C2A29]">
                Read our affiliate disclaimer
              </Link>
              .
            </div>
          </div>

          <div className="md:col-span-2 lg:col-span-3" />

          <div className="md:col-span-4 lg:col-span-4 grid grid-cols-2 gap-8">
            <section aria-labelledby="footer-explore-heading">
              <h2
                id="footer-explore-heading"
                className="font-bold text-[#2C2A29] text-xs uppercase tracking-widest mb-4"
              >
                Explore
              </h2>
              <ul className="space-y-3 text-sm text-[#6B6661]">
                <li>
                  <Link to="/" className="hover:text-[#2C2A29] hover:underline">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="hover:text-[#2C2A29] hover:underline">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/directory" className="hover:text-[#2C2A29] hover:underline">
                    Directory
                  </Link>
                </li>
              </ul>
            </section>

            <section aria-labelledby="footer-legal-heading">
              <h2
                id="footer-legal-heading"
                className="font-bold text-[#2C2A29] text-xs uppercase tracking-widest mb-4"
              >
                Legal
              </h2>
              <ul className="space-y-3 text-sm text-[#6B6661]">
                <li>
                  <Link to="/privacy" className="hover:text-[#2C2A29] hover:underline">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="hover:text-[#2C2A29] hover:underline">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link to="/disclaimer" className="hover:text-[#2C2A29] hover:underline">
                    Disclaimer
                  </Link>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={openCookieSettings}
                    className="hover:text-[#2C2A29] hover:underline text-left"
                  >
                    Cookie settings
                  </button>
                </li>
              </ul>
            </section>
          </div>
        </div>

        <div className="pt-8 border-t border-[#E5E0D8] flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#8A847A]">
          <p>© {new Date().getFullYear()} CurateEd. All rights reserved.</p>
          <p>Designed for aesthetic learning.</p>
        </div>
      </div>
    </footer>
  );
}